import 'antd/dist/reset.css'
import React, { FC } from 'react'

import 'styles/customize.antd.css'

import AppRoutes from './AppRoutes'

const App: FC = () => {
  return <AppRoutes />
}

export default App
